import $ from "jquery";
import "what-input";
window.jQuery = $;

import "magnific-popup/dist/jquery.magnific-popup.js";
import "./lib/foundation-explicit-pieces";
import { editableSvg, isInViewport } from "./lib/utilities";
import "slick-carousel/slick/slick";

$(document).foundation();

$(function() {
  /* slick slider */
  $("[data-slick]").slick();

  /* Replace all SVG images with inline SVG */
  editableSvg("img.editable-svg");

  /* Sticky header */

  //clone the header
  //   $(".site-header")
  //     .clone()
  //     .addClass("sticky")
  //     .attr("tabindex", -1)
  //     .insertAfter(".site-header");

  //   if (
  //     $(".primary-navigation-submenu").length &&
  //     !$(".site-header.sticky .primary-navigation-submenu").length
  //   ) {
  //     $(".primary-navigation-submenu")
  //       .clone()
  //       .appendTo(".site-header.sticky");
  //   }

  window.onscroll = function() {
    revealHeader();
  };
  const header = document.querySelector(".site-header:not(.sticky)");
  //   const stickyHeader = document.querySelector(".site-header.sticky");
  const offset = header.offsetHeight;

  function revealHeader() {
    if (window.pageYOffset > offset) {
      header.classList.add("stuck");
    } else {
      header.classList.remove("stuck");
      //   $(stickyHeader)
      //     .find("li.menu-item-has-children ul")
      //     .slideUp("fast");
    }
  }
  /* end Sticky header */

  /******** set cookie on shop page *********/

  function setCookie(cname, cvalue) {
    document.cookie = cname + "=" + cvalue + ";" + ";path=/";
  }

  $("#close-button-notification").on("click", function() {
    setCookie("dgc-session-notification", true);
  });

  /******** end set cookie on shop page *********/

  /* Hamburger click handle */
  $(".hamburger").on("click", function() {
    $("body").toggleClass("offcanvas-active");
  });

  /* Offcanvas close button handle */
  $(".off-canvas .close-button").on("click", function() {
    $("body").removeClass("offcanvas-active");
  });

  /* wrap button copy with <span> */

  function wrapButtons() {
    $("a.button, button.button, li.button > a").each(function() {
      $(this).html("<span>" + $(this).text() + "</span>");
    });

    $("input.button").each(function() {
      let classes = "button";
      $(this).removeClass("button");

      if ($(this).hasClass("simple")) {
        classes += " simple";
        $(this).removeClass("simple");
      }

      if ($(this).hasClass("secondary")) {
        classes += " secondary";
        $(this).removeClass("secondary");
      }

      $(this).wrap('<div class="input-button ' + classes + '"></div>');
      $('<i class="line"></i>').insertAfter($(this));
    });
  }

  wrapButtons();

  $(document).on("gform_post_render", function(event, formId) {
    wrapButtons();
  });

  /* primary submenu navigation */
  // let currentMenuItems = $('body:not(.home) .primary-navigation .current-menu-item');
  // let currentMenuItem = null;

  // currentMenuItems.each(function(){
  //     let menu = $(this);

  //     if(menu.parent('ul').parent('li').length == 0) {
  //         //first level
  //         currentMenuItem = menu;
  //         return;
  //     } else {
  //         //second level
  //         currentMenuItem = menu.parent('ul').parent('li');
  //         currentMenuItem.addClass('current-menu-item');
  //         return;
  //     }
  // });

  // if(currentMenuItem) {
  //     let submenu = currentMenuItem.find('ul').clone().insertAfter('.site-header:not(.sticky) > .navbar');
  //     submenu.addClass('has-' + submenu.find('li').length + '-items');
  //     submenu.wrap('<div class="primary-navigation-submenu show-for-large">');
  //     $('.primary-navigation-submenu').fadeIn();
  // }

  /* Sliders */
  const testimonialsCarousel = $(".template-testimonials .carousel");

  testimonialsCarousel.each(function() {
    const slider = $(this);
    const buttons = slider.parent().find(".carousel-buttons");
    const dots = slider.parent().find(".carousel-dots");

    slider.on("init", function(event, slick) {
      if (!(slider.find(".slick-slide").length > 1)) {
        slider.addClass("has-1-slide");
      }
    });

    slider.slick({
      arrows: true,
      dots: true,
      appendArrows: buttons,
      appendDots: dots
    });
  });

  const imageSliders = $(".image-carousel");

  imageSliders.each(function() {
    const slider = $(this);
    const buttons = slider.parent().find(".carousel-buttons");
    const dots = slider.parent().find(".carousel-dots");

    slider.on("init", function(event, slick) {
      if (!(slider.find(".slick-slide").length > 1)) {
        slider.addClass("has-1-slide");
      }
    });

    slider.slick({
      arrows: true,
      dots: true,
      appendArrows: buttons,
      appendDots: dots,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerMode: true
          }
        },
        {
          breakpoint: 1300,
          settings: {
            centerMode: true,
            variableWidth: true
          }
        }
      ]
    });
  });
  
  const featuredProjectSliders = $(".featured-project-carousel");

  featuredProjectSliders.each(function() {
    const slider = $(this);
    const buttons = slider.parent().find(".carousel-buttons");
    const dots = slider.parent().find(".carousel-dots");
    
    // slider.on('beforeChange', (event, slick, currentSlide, nextSlide) => {
    //       if (currentSlide !== nextSlide) {
    //           document.querySelectorAll('.slick-cloned').forEach((next) => {
    //               // timeout required or Slick will overwrite the classes
    //               setTimeout(() => next.classList.add('slick-active'));
    //           });
    //       }
    //   });

    slider.on("init", function(event, slick) {
      if (!(slider.find(".slick-slide").length > 1)) {
        slider.addClass("has-1-slide");
      }
    });

    slider.slick({
      speed: 500,
      infinite: true,
      cssEase: 'linear',
      arrows: true,
      dots: true,
      appendArrows: buttons,
      appendDots: dots,
      mobileFirst: true,
      waitForAnimate: true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            centerMode: true
          }
        },
        {
          breakpoint: 1280,
          settings: {
            centerMode: false,
            //centerPadding: '0px',
            //variableWidth: true,
            slidesToShow: 2,
            slidesToScroll: 2,
          }
        }
      ]
    });
  });

  /* video popup */
  if ($(".popup-video").length) {
    $(".popup-video").magnificPopup({
      disableOn: 700,
      type: "iframe",
      mainClass: "mfp-fade",
      removalDelay: 160,
      preloader: false,
      fixedContentPos: false
    });
  }

  /* load more posts */
  function loadMore() {
    let loadMoreButtons = $(".load-more .button");
    loadMoreButtons.each(function() {
      let button = $(this);
      let sliceNumber = 3;
      let hiddenCells = null;

      if (
        button.parents(".content-block").hasClass("template-projects-archive")
      ) {
        sliceNumber = 20;
      }

      button.on("click", function(e) {
        e.preventDefault();
        hiddenCells = button.parents(".content-block").find(".cell:hidden");
        hiddenCells.slice(0, sliceNumber).slideDown();

        $("html,body")
          .stop()
          .animate(
            {
              scrollTop:
                $(hiddenCells[0]).offset().top -
                $(".site-header.stuck").innerHeight() -
                15
            },
            1000
          );
        if (!button.parents(".content-block").find(".cell:hidden").length) {
          button.fadeOut("slow");
        }
      });
    });
  }

  loadMore();

  /* filter */

  //add and remove class disabled for 'All' button
  function disabledEnableAllButton() {
    $(".filter-list .facetwp-checkbox.all").each(function() {
      let name = $(this).attr("data-value");
      let category = $(this).attr("data-name");

      if (FWP.facets[category].includes(name)) {
        $(this).addClass("checked");
      } else {
        $(this).removeClass("checked");
      }
    });
  }

  $(".filter-list .facetwp-checkbox.all").on("click", function() {
    let category = $(this).attr("data-name");
    let name = $(this).attr("data-value");
    let checked = false;
    let facet = FWP.facets[category];

    if (facet.includes(name)) {
      checked = true;
    }

    if (checked) {
      //FWP.facets[category] = [];
      facet.splice(facet.indexOf(name), 1);
    } else {
      FWP.facets[category].push(name);
    }

    FWP.is_reset = true;
    FWP.refresh();
  });

  $(document).on("click", ".filter-list .facetwp-checkbox", function() {
    disabledEnableAllButton();
  });

  //accordion
  $(".filter-title").on("click", function() {
    let parent = $(this).parents(".filter-category");
    if (!parent.hasClass("opened")) {
      parent.addClass("opened");
      parent.find(".filter-list").slideDown();
    } else {
      parent.removeClass("opened");
      parent.find(".filter-list").slideUp();
    }
  });

  //clear all button
  if (window.FWP) {
    $(".clear-filters-button").on("click", function(e) {
      e.preventDefault();
      FWP.reset();
      $(".facetwp-checkbox.all").removeClass("disabled");
    });
  }

  function fileInputButton() {
    $(".ginput_container_fileupload").each(function() {
      var container = $(this);
      var label = $(this)
        .parent()
        .find("label");
      let styled = false;

      if (container.hasClass("styled") == false) {
        container.addClass("styled");
        styled = true;
        if (label && label.length) {
          label.detach().insertAfter(container.find('[type="file"]'));
        }
      }
    });

    var inputs = document.querySelectorAll(
      '.ginput_container_fileupload [type="file"]'
    );
    Array.prototype.forEach.call(inputs, function(input) {
      var label = input.nextElementSibling,
        labelVal = label.innerHTML;

      input.addEventListener("change", function(e) {
        var fileName = "";

        if (this.files) fileName = e.target.value.split("\\").pop();

        if (fileName) label.innerHTML = fileName;
        else label.innerHTML = labelVal;
      });
    });
  }

  fileInputButton();

  function checkIfSubmitDisabled() {
    const submits = $('.gform_wrapper [type="submit"]');
    submits.each(function() {
      console.log($(this).css("display"));
      if ($(this).css("display") == "none") {
        if (
          $(this)
            .parent()
            .hasClass("input-button")
        ) {
          $(this)
            .parent()
            .addClass("disabled");
        }
      } else {
        if (
          $(this)
            .parent()
            .hasClass("input-button")
        ) {
          $(this)
            .parent()
            .removeClass("disabled");
        }
      }
    });
  }

  $(document).on("facetwp-loaded", function() {
    disabledEnableAllButton();

    //open the accordion with checked checkboxes on page load
    $(".filter-category").each(function() {
      let category = $(this);
      let categoryIsActive = false;

      category.find(".facetwp-checkbox").each(function() {
        if ($(this).hasClass("checked")) {
          categoryIsActive = true;
        }
      });

      if (categoryIsActive) {
        category.addClass("opened");
        category.find(".filter-list").slideDown();
      }
    });
    
    // Handle dropdown selected state
    $(".filter-dropdown select").each(function() {
      if ($(this).val() !== "") {
        $(this).closest('.filter-category').addClass('active');
      } else {
        $(this).closest('.filter-category').removeClass('active');
      }
    });

    if (!$(".template-projects-archive .block-grid > .cell:hidden").length) {
      $(".template-projects-archive .load-more .button").hide();
    } else {
      $(".template-projects-archive .load-more .button").show();
    }

    fileInputButton();
  });

  $(document).on("gform_confirmation_loaded", function(event, formId) {
    const target = $("#gform_confirmation_wrapper_" + formId);
    const offset = $(".site-header").innerHeight() + 30;
    $("html,body")
      .stop()
      .animate({ scrollTop: target.offset().top - offset }, 1000);
    fileInputButton();
  });

  //added a not selector so this toggle no longer affects the footer menu
  // Switched this to using foundation's built in functionality. This was a bit broken, and not accessible.
  // $(
  //   "ul:not(.footer-menu, .offcanvas-primary-menu) li.menu-item-has-children"
  // ).hover(
  //   function(e) {
  //     $(this)
  //       .parent()
  //       .find("ul")
  //       .stop()
  //       .slideToggle("fast");
  //   },
  //   function() {
  //     $(this)
  //       .parent()
  //       .find("ul")
  //       .stop()
  //       .slideToggle("fast");
  //   }
  // );

  //this code was making the document scroll automatically to the gravity form...weird
  // jQuery(document).on('gform_post_render', function(event, formId) {

  //     const target = $('#gform_' + formId);
  //     const offset = $('.site-header').innerHeight() + 30;
  //     $('html,body').stop().animate({ scrollTop: target.offset().top - offset }, 1000);
  //     fileInputButton();
  // });

  $(document).click(function(e) {
    e.stopPropagation();
    var container = $("li.menu-item-has-children");

    //check if the clicked area is dropDown or not
    if (container.has(e.target).length === 0) {
      $("li.menu-item-has-children")
        .find("ul")
        .slideUp("fast");
    }
  });
});

jQuery(document).ready(function($) {
  let $body = $("body");
  let $element_after_header = $("header").next(".container");

  $element_after_header.attr("id", "main_content");
  $body.prepend(
    "<a id='skip_to_content' class='show-on-focus button default' href='#main_content'>Skip to content</a>"
  );

  $("li.menu-item > a").attr("tabindex", "0");
});

// Smooth scroll to hash links with offset
jQuery(document).ready(function($) {
  // Function to handle smooth scrolling
  function smoothScrollToHash(hash) {
    if (!hash) return;
    
    const target = $(hash);
    if (target.length) {
      const offset = $(window).width() >= 768 ? 240 : 120;
      $('html, body').animate({
        scrollTop: target.offset().top - offset
      }, 800);
    }
  }

  // Handle clicks on hash links
  $('a[href*="#"]:not([href="#"])' + 
    ':not([href*="#tab-"])'+ // Exclude tab links
    ':not([data-toggle])' +  // Exclude Bootstrap toggles
    ':not([data-slide])' +   // Exclude carousel controls
    ':not([data-bs-toggle])' + // Exclude Bootstrap 5 toggles
    ':not([role="tab"])' +   // Exclude tab roles
    ':not(.popup-video)' +   // Exclude video popups (from your existing magnific popup)
    ':not(.no-smooth-scroll)' // Exclude any manually flagged links
  ).on('click', function(event) {
    if (
      location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') &&
      location.hostname === this.hostname
    ) {
      event.preventDefault();
      smoothScrollToHash(this.hash);
    }
  });

  // Handle hash in URL on page load
  $(window).on('load', function() {
    if (window.location.hash) {
      setTimeout(function() {
        smoothScrollToHash(window.location.hash);
      }, 100);
    }
  });
});

jQuery(document).ready(function($) {
  $("body").on("click", ".clickable-box", function(e) {
    const box = $(this);
    const a_tag = box.find("a:first");
    const no_text_selected = !window.getSelection().toString();

    if (a_tag.length && no_text_selected) {
      const href = a_tag.attr("href");
      const target = a_tag.attr("target");

      if (href) {
        if (target === "_blank") {
          // Open in new window/tab
          window.open(href, "_blank");
        } else {
          // Use original link behavior
          a_tag[0].click();
        }
      }
    }
  });

  // check each clickable box for a link. if none, change the cursor
  $(".clickable-box").each(function() {
    let href = $(this).find("a:first");
    if (!href.length) {
      $(this).css("cursor", "initial");
    }
  });
});

